/** @jsx jsx */

import { Link, graphql, useStaticQuery } from "gatsby"

import { css } from "@emotion/core"
import { headerStyles } from "./header"
import { jsx } from "theme-ui"

function LogoLink() {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
    <Link to={`/`}>
      <h1
        sx={headerStyles}
        css={css`
          display: inline-block;
          font-style: normal;
        `}
      >
        {data.site.siteMetadata.title}
      </h1>
    </Link>
  )
}

export default LogoLink
